import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/auth.context";
import { Skeleton } from "@/components/ui/skeleton";

const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    // Mostrar loading enquanto verifica autenticação
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="space-y-3">
          <Skeleton className="h-12 w-12 rounded-full mx-auto" />
          <Skeleton className="h-4 w-32" />
        </div>
      </div>
    );
  }

  // Se não estiver autenticado, redirecionar para login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Renderizar a rota protegida
  return <Outlet />;
};

export default ProtectedRoute;
